import { BaseDialog, Button, Tabs } from '@app/components';
import { OptionInterface } from '@app/models/util';
import { GenericTable } from '@app/components/GenericTable/GenericTable';
import {AutomationsFilters} from "@app/components/AutomationsFilters/AutomationsFilters.tsx";
import { useAutomations } from './Automations.hooks';
import CloseIcon from '@app/assets/icons/close.svg?react';
import AutomationIcon from '@app/assets/icons/automation-button.svg?react';
import BinIcon from '@app/assets/icons/bin.svg?react';
import CalendarIcon from '@app/assets/icons/calendar-01.svg?react';
import CalendarCheckIcon from '@app/assets/icons/calendar-check.svg?react';
import { toast } from 'react-toastify';
import NoDraftsIllustration from '@app/assets/illustrations/no-drafts.png';
import NoAutomationsIllustration from '@app/assets/illustrations/no-automations.png';
import NoAutomationsCancelledIllustration from '@app/assets/illustrations/no-automations-cancelled.png';
import NoAutomationsPausedIllustration from '@app/assets/illustrations/no-automations-paused.png';
// import NoCampaignIllustration from '@app/assets/illustrations/no-campaigns.svg?react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@app/contexts/PermissionContext';
import { useAppDispatch } from '@app/redux/hooks';
import { updateFormData } from '@app/redux/features/campaignForm';
import { reviewTemplate } from '@app/components/EmailTemplateEditor/templates';
import dayjs from 'dayjs';
import { AutomationsTableRow } from '@app/components/AutomationsTableRow/AutomationsTableRow.tsx';
import {cancelAutomation, deleteAutomation, getAutomation} from "@app/services/automations.ts";
import {AUTOMATION_STATUS_VALUE} from "@app/models/automations.ts";

export const Automations = () => {
  const {
    // createSecheduleModal,
    // handleCreateScheduleModal,
    automationsData,
    createAutomation,
    // createCampaign,
    handleDeleteModal,
    deleteModal,
    handleCancelModal,
    cancelModal,
    refetch,
    filterForm,
    handleLimitChange,
    handleNextPage,
    handlePreviousPage,
    page,
    limit,
    searchValue,
    setSearchValue,
    sortBy,
    sortOrder,
    currentFilterStatus,
    setCurrentFilterStatus,
    handleSortingTable,
  } = useAutomations();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { can } = usePermissions();
  const [highlightedAutomationId, sethighlightedAutomationId] = useState<string | null>(null);
  const highlightTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
  const [isFiltering, setIsFiltering] = useState(false);
  // const [currentFilterStatus, setCurrentFilterStatus] = useState<string>('all');
  // const [currentFilterStatus, setCurrentFilterStatus] = useState<string>('active');

  const automationsTabs = [
    { value: 'all', label: 'All', count: automationsData?.statusCounts?.total },
    {
      value: AUTOMATION_STATUS_VALUE.ACTIVE,
      label: 'Active',
      count: (automationsData?.statusCounts ?? {})[AUTOMATION_STATUS_VALUE.ACTIVE],
    },
    {
      value: AUTOMATION_STATUS_VALUE.PAUSED,
      label: 'Paused',
      count: (automationsData?.statusCounts ?? {})[AUTOMATION_STATUS_VALUE.PAUSED],
    },
    // {
    //   value: 'completed',
    //   label: 'Completed',
    //   count: automationsData?.statusCounts?.completed,
    // },
    {
      value: AUTOMATION_STATUS_VALUE.CANCELLED,
      label: 'Cancelled',
      count: (automationsData?.statusCounts ?? {})[AUTOMATION_STATUS_VALUE.CANCELLED],
    },
    {
      value: AUTOMATION_STATUS_VALUE.DRAFT,
      label: 'Drafts',
      count: (automationsData?.statusCounts ?? {})[AUTOMATION_STATUS_VALUE.DRAFT],
    },
  ];

  const getScheduleSummary = (campaign: any) => {
    if (!campaign.schedules || campaign.schedules.length === 0) {
      return null;
    }

    const now = dayjs();
    const pastSchedules = campaign.schedules.filter((schedule: any) =>
      dayjs(schedule.start).isBefore(now)
    );
    const futureSchedules = campaign.schedules.filter((schedule: any) =>
      dayjs(schedule.start).isAfter(now)
    );

    return {
      pastCount: pastSchedules.length,
      futureCount: futureSchedules.length,
      pastSchedules,
      futureSchedules,
    };
  };


  const deleteAutomationAction = async () => {
    if (!deleteModal) return;

    await deleteAutomation(deleteModal.id)
      .then(async () => {
        await refetch();
        toast.success('Automation deleted successfully');
      })
      .catch(() => {
        toast.error('Failed to delete automation');
      })
      .finally(() => handleDeleteModal(undefined));
  };

  const cancelAutomationAction = async () => {
    if (!cancelModal) return;

    cancelAutomation(cancelModal.id)
      .then(async () => {
        await refetch();
        toast.success('Automation cancelled successfully');
      })
      .catch(() => {
        toast.error('Failed to cancel automation');
      })
      .finally(() => handleCancelModal(undefined));

  };

  const handleTabClick = (tabValue: string) => {
    // Set filtering state
    setIsFiltering(true);
    setCurrentFilterStatus(tabValue);

    // Reset page to 1 when filtering by changing limit (which resets page)
    handleLimitChange(limit);

    // if (tabValue === 'all') {
    //   // Clear status filter for "all" tab
    //   filterForm.setValue('statuses', []);
    //   filterForm.setValue('scheduled', false);
    // } else if (tabValue === 'scheduled') {
    //   // Set scheduled filter for "scheduled" tab
    //   filterForm.setValue('statuses', ['scheduled']);
    //   filterForm.setValue('scheduled', true);
    // } else {
    //   // Set status filter for other tabs
    //   filterForm.setValue('statuses', [tabValue]);
    //   filterForm.setValue('scheduled', false);
    // }
  };

  const handleHighlightAutomation = (automationId: string) => {
    // Clear any existing timeout
    if (highlightTimeoutRef.current) {
      clearTimeout(highlightTimeoutRef.current);
    }

    sethighlightedAutomationId(automationId);

    // Store the highlighted campaign ID in sessionStorage to persist through re-renders
    sessionStorage.setItem('highlightedCampaignId', automationId);
    sessionStorage.setItem('highlightStartTime', Date.now().toString());

    // Remove highlight after 8 seconds
    highlightTimeoutRef.current = setTimeout(() => {
      sethighlightedAutomationId(null);
      sessionStorage.removeItem('highlightedCampaignId');
      sessionStorage.removeItem('highlightStartTime');
    }, 8000);
  };

  const handleAutomationClick = async (automationId: string, status: string) => {
    // Check for draft status (case-insensitive and handle variations)
    const isDraftStatus = status === AUTOMATION_STATUS_VALUE.DRAFT;

    if (isDraftStatus) {
      try {
        // Fetch the campaign data
        const response = await getAutomation(automationId);
        const automationData = response.data.data || response.data;

        // Transform campaign data to form format
        const formData = {
          automationId: automationData.id,
          eventSource: automationData.eventSource,
          eventName: automationData.eventName,
          sendFollowUp: automationData.followUpsUse,

          automationName: automationData.name,
          description: automationData.description,
          channels: automationData.channels?.split(',') || [],

          businessName: automationData.senderName,
          businessAddress: automationData.senderAddress,
          businessEmail: automationData.senderEmail,
          echoRatingsPhoneNumber: automationData.senderPhone,


          lists: automationData.lists?.map((l: any) => l.id) ?? [],
          tags: automationData.tags?.map((t: any) => t.id) ?? [],
          ...(automationData.followUps?.reduce(
              (result: any, followUp: any) => {
                const indexVal = followUp.index - 1;
                // result[`followUpId${indexVal}`] = followUp.id;
                result[`followUpDays${indexVal}`] = followUp.value;
                result[`followUpPeriod${indexVal}`] = followUp.period;

                return result;
              },
              {},
          ) ?? {}),

          ...(automationData.emailDesigns?.reduce(
              (result: any, design: any) => {

                if (design.type === 'email') {
                  result.emailTemplate = reviewTemplate;
                  result.emailDesignContent = {
                    "buttonColor": design.buttonColor,
                    "buttonText": design.buttonText,
                    "heading": design.heading,
                    "logoUrl": design.logo,
                    "message": design.message,
                    "subject": design.subject,
                  };
                } else if (design.type === 'sms') {
                  result.textTemplate = 'sms';
                  result.messageDesignContent = {
                    "logoUrl": design.logo,
                    "message": design.message,
                    "previewName": design.heading,
                  };
                }

                return result;
              },
              {},
          ) ?? {}),

        };

        // Save to Redux and localStorage
        dispatch(updateFormData(formData));
        localStorage.setItem('automationFormData', JSON.stringify(formData));

        // Navigate to create campaign settings
        navigate('/automations/create/settings'); // todo: redirect regarding type
      } catch (error) {
        console.error('Error fetching campaign data:', error);
        // Fallback to normal navigation
        navigate(`/automations/${automationId}`);
      }
    } else {
      // Normal navigation for non-draft campaigns
      navigate(`/automations/${automationId}`);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    // if (urlParams.has('schedule')) {
    //   handleCreateScheduleModal();
    // }
    if (urlParams.has('highlight')) {
      const highlightId = urlParams.get('highlight');
      if (highlightId) {
        handleHighlightAutomation(highlightId);
        // Clear the URL parameter after handling it
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('highlight');
        window.history.replaceState({}, '', newUrl.toString());
      }
    }
  }, []);

  // Restore highlighting from sessionStorage when component mounts or data changes
  useEffect(() => {
    const storedHighlightId = sessionStorage.getItem('highlightedCampaignId');
    const storedStartTime = sessionStorage.getItem('highlightStartTime');

    if (storedHighlightId && storedStartTime) {
      const startTime = parseInt(storedStartTime);
      const elapsed = Date.now() - startTime;
      const remainingTime = Math.max(8000 - elapsed, 0);

      if (remainingTime > 0) {
        sethighlightedAutomationId(storedHighlightId);

        // Set timeout for remaining time
        highlightTimeoutRef.current = setTimeout(() => {
          sethighlightedAutomationId(null);
          sessionStorage.removeItem('highlightedCampaignId');
          sessionStorage.removeItem('highlightStartTime');
        }, remainingTime);
      } else {
        // Clear expired highlighting
        sessionStorage.removeItem('highlightedCampaignId');
        sessionStorage.removeItem('highlightStartTime');
      }
    }
  }, [automationsData]);

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
    };
  }, []);

  // Track if filters have been applied
  useEffect(() => {
    const formValues = filterForm.getValues();
    const hasFilters =
      (formValues.statuses &&
        Array.isArray(formValues.statuses) &&
        formValues.statuses.length > 0) ||
      (formValues.statuses &&
        !Array.isArray(formValues.statuses) &&
        formValues.statuses !== 'all') ||
      formValues.scheduled ||
      (formValues.channels && formValues.channels !== 'all') ||
      (formValues.from && formValues.from !== '') ||
      (formValues.to && formValues.to !== '') ||
      searchValue.length > 0;

    setHasAppliedFilters(hasFilters);

    // // Only update currentFilterStatus if it's a simple scheduled filter or no filters
    // // Don't change the tab when complex filters are applied through filter fields
    // if (formValues.scheduled && !hasOtherFilters(formValues)) {
    //   setCurrentFilterStatus('scheduled');
    //   setIsFiltering(true);
    // } else if (!hasFilters) {
    //   // Reset filtering state when no filters are applied
    //   setIsFiltering(false);
    //   setCurrentFilterStatus('all');
    // } else {
    //   // For complex filters, just set filtering to true but don't change the tab
    //   setIsFiltering(true);
    // }
  }, [filterForm.watch(), searchValue]);

  // Helper function to check if there are other filters besides scheduled
  const hasOtherFilters = (formValues: any) => {

    const hasNonStatusFilters =
      (formValues.statuses && formValues.statuses !== 'all') ||
      (formValues.channels && formValues.channels !== 'all') ||
      (formValues.from && formValues.from !== '') ||
      (formValues.to && formValues.to !== '') ||
      searchValue.length > 0;

    return hasNonStatusFilters;
  };

  // Empty state configuration for different campaign statuses
  const getEmptyStateConfig = (): {
    image: any;
    header: string;
    description: string;
  } => {
    // If there are complex filters applied, show generic message
    const formValues = filterForm.getValues();
    const hasComplexFilters = hasOtherFilters(formValues);

    if (hasComplexFilters) {
      return {
        // image: <img src={NoAutomationsIllustration} alt="No automations" className="w-32 h-32" />,
        image: NoAutomationsIllustration,
        header: 'No automations found',
        description: 'No automations match your current filters',
      };
    }

    switch (currentFilterStatus) {
      case 'active':
        return {
          image: NoAutomationsIllustration,
          header: 'No active automations',
          description: 'Automations that are currently running will be displayed here.',
        };
      case 'paused':
        return {
          image: NoAutomationsPausedIllustration,
          header: 'No paused automations',
          description: 'Automations that have been paused will be displayed here',
        };
      // case 'completed':
      //   return {
      //     image: NoAutomationsIllustration,
      //     header: 'No completed automations',
      //     description: 'Campaigns that have been fully sent and completed will be displayed here',
      //   };
      case 'cancelled':
        return {
          image: NoAutomationsCancelledIllustration,
          header: 'No cancelled automations',
          description: 'Automations that have been cancelled will be displayed here',
        };
      case 'draft':
        return {
          image: NoDraftsIllustration,
          header: 'No drafts',
          description: 'Automation that have not been started will be displayed here',
        };
      default:
        return {
          image: NoAutomationsIllustration,
          header: 'No automations found',
          description: 'No automations match your current filters',
        };
    }
  };

  return (
    <>
      <div>
        <div className="bg-white border-b border-b-base-ghostWhite ">
          <div className="container mx-auto pt-4 px-4 space-y-2">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <h2 className="font-bold text-[28px] mb-2">Automations</h2>
              {can('createAutomations') && (
                <Button onClick={createAutomation} leftNode={<AutomationIcon className="[&_path]:fill-white" />}>
                  Set up new automation
                </Button>
              )}
            </div>
            {((automationsData?.total ?? 0) > 0 || hasAppliedFilters || isFiltering || true) && (
              <>
                <AutomationsFilters
                  filterForm={filterForm}
                  showReset={(() => {
                    const formValues = filterForm.getValues();
                    const hasActiveFilters =
                      (formValues.statuses && Array.isArray(formValues.statuses) && formValues.statuses.length > 0) ||
                      (formValues.channels && Array.isArray(formValues.channels) && formValues.channels.length > 0) ||
                      (formValues.platforms && Array.isArray(formValues.platforms) && formValues.platforms.length > 0) ||
                      (formValues.from && formValues.from !== '') ||
                      (formValues.to && formValues.to !== '') ||
                      formValues.scheduled ||
                      searchValue.trim() !== '';
                    return hasActiveFilters;
                  })()}
                  onReset={() => {
                    // Reset form values
                    filterForm.reset();
                    // Explicitly clear multi-select filter values
                    filterForm.setValue('statuses', []);
                    filterForm.setValue('channels', []);
                    filterForm.setValue('platforms', []);
                    filterForm.setValue('from', '');
                    filterForm.setValue('to', '');
                    filterForm.setValue('scheduled', false);
                    // Reset search value
                    setSearchValue('');
                    // Reset filtering states
                    setIsFiltering(false);
                    setHasAppliedFilters(false);
                    setCurrentFilterStatus('all');
                  }}
                />
                <Tabs tabs={automationsTabs as unknown as OptionInterface[]} onClick={handleTabClick} defaultValue={currentFilterStatus} />
              </>
            )}
          </div>
        </div>
        {((automationsData?.total ?? 0) > 0 || hasAppliedFilters || isFiltering) && (
          <div className="bg-white">
            <div className="container mx-auto py-6 px-4 flex flex-col md:flex-row justify-between items-end md:items-center gap-4">
              <h3 className="text-2xl font-bold">{automationsData?.total} automations</h3>
              <div>
                <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl">
                  <input
                    type="text"
                    className="w-full border-0 border-b border-gray-300 text-base sm:text-lg py-2 pr-10 focus:outline-none focus:ring-0 focus:border-gray-400 bg-transparent placeholder:text-gray-400"
                    placeholder="Search"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      if (e.target.value.length > 0) {
                        setIsFiltering(true);
                      }
                    }}
                    style={{ fontWeight: 400 }}
                  />
                  <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400" aria-label="Search">
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
                      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                      <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M21 21l-3.5-3.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container mx-auto py-6 px-4 ">
          {/* Show original "No campaigns" state when no campaigns exist and no filtering */}
          {(!automationsData || automationsData.total === 0) && !hasAppliedFilters && !isFiltering && (
            <div className="flex items-center justify-center flex-col max-w-[350px] mx-auto space-y-4 h-full mt-40">
              <img src={NoAutomationsIllustration} alt="No Automations" className="w-36 h-36" />
              <p className="font-bold">No automations</p>
              <p className="text-sm text-base-coolGray text-center">You don't have any automations added yet.</p>
              {can('createAutomations') && (
                <Button onClick={createAutomation} leftNode={<AutomationIcon className="[&_path]:fill-white" />} className="w-full">
                  Set up new automation
                </Button>
              )}
            </div>
          )}

          {/* Show filtered empty states when filtering is active and no results */}
          {automationsData && automationsData.total === 0 && (hasAppliedFilters || isFiltering) && (() => {
              const emptyState = getEmptyStateConfig();
              const ImageComponent = emptyState.image;

              return (
                <div className="flex items-center justify-center flex-col max-w-[350px] mx-auto space-y-4 h-full mt-40">
                  {typeof ImageComponent === 'string' ? <img src={ImageComponent} alt="No automations" className="w-32 h-32" /> : <ImageComponent />}
                  <p className="font-bold">{emptyState.header}</p>
                  <p className="text-sm text-base-coolGray text-center whitespace-pre-line">{emptyState.description}</p>
                  {can('createAutomations') && ((currentFilterStatus !== 'cancelled' && currentFilterStatus !== 'draft') || hasOtherFilters(filterForm.getValues())) ? (
                    <Button onClick={createAutomation} kind="primary" leftNode={<AutomationIcon className="[&_path]:fill-white" />}>
                      Set up new automation
                    </Button>
                  ) : null}
                </div>
              );
            })()}
          {automationsData && (
            <div className="bg-white overflow-auto">
              <GenericTable
                data={automationsData?.automations ?? []}
                currentPage={page}
                headers={[
                  { label: 'Automation', field: 'name', sortable: true },
                  { label: 'Channels', field: 'channels', sortable: true },
                  { label: 'Status', field: 'status', sortable: true },
                  { label: 'Started', field: 'started', sortable: false, textAlign: 'right' },
                  { label: 'Completed', field: 'completed', sortable: false, textAlign: 'right' },
                  // {
                  //   label: 'Customers',
                  //   field: 'customerCount',
                  //   sortable: true,
                  // },
                ]}
                renderRow={(data) =>
                  data.map((row) => (
                    <AutomationsTableRow
                      key={row.id}
                      data={row}
                      onClick={() => handleAutomationClick(row.id, row.status)}
                      refetch={refetch}
                      onDelete={handleDeleteModal}
                      onCancel={handleCancelModal}
                      isHighlighted={highlightedAutomationId === row.id}
                      onHighlight={handleHighlightAutomation}
                      disabledActions={{
                        deleteAutomation: !can('cancelAutomations'),
                        cancelAutomation: !can('cancelAutomations'),
                        pauseAutomation: !can('createAutomations'),
                      }}
                    />
                  ))
                }
                isLoading={false}
                currentSortBy={sortBy}
                currentSortOrder={sortOrder}
                onSort={handleSortingTable}
                pagination={{
                  total: automationsData?.total ?? 0,
                  handleNextPage: handleNextPage,
                  handlePrevPage: handlePreviousPage,
                  handleLimitChange: handleLimitChange,
                }}
              />
            </div>
          )}
        </div>
      </div>
      <BaseDialog size="max-w-2xl" open={Boolean(deleteModal)} onClose={() => handleDeleteModal()}>
        <div className="border-b border-b-base-ghostWhite p-6 mb-6 flex gap-2 items-start justify-between">
          <div className="bg-base-antiFlash flex items-center p-2 rounded-lg">
            <BinIcon width={24} height={24} />
          </div>
          <div className="mr-auto my-auto">
            <h5 className="font-bold text-lg">Delete automation</h5>
          </div>
          <div>
            <button type="button" onClick={() => handleDeleteModal()}>
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className="px-6 pb-4">
          <p className="text-base-davyGray mb-4">Are you sure you want to delete this automation? All data about it will be deleted from the database.</p>

          {deleteModal &&
            (() => {
              const scheduleSummary = getScheduleSummary(deleteModal);

              if (scheduleSummary && scheduleSummary.futureCount > 0) {
                const { pastCount, futureCount, pastSchedules, futureSchedules } = scheduleSummary;

                return (
                  <div className="mb-4">
                    <p className="font-bold text-base-davyGray mb-3">
                      {pastCount > 0
                        ? `This automation has been sent ${pastCount} time${pastCount > 1 ? 's' : ''}, and ${futureCount} more ${futureCount > 1 ? 'are' : 'is'} scheduled.`
                        : `This automation has not been sent yet.`}
                    </p>

                    <div className="bg-gray-100 rounded-lg p-4 space-y-3">
                      {pastSchedules.length > 0 && (
                        <div className="flex items-center gap-2">
                          <div className="bg-green-100 p-1 rounded-sm flex items-center justify-center">
                            <CalendarCheckIcon className="w-4 h-4" />
                          </div>
                          <span className="text-sm text-gray-700">Sent on:</span>
                          <span className="text-sm text-gray-700">{pastSchedules.map((schedule: any) => dayjs(schedule.start).format('MMM DD, YYYY')).join(', ')}</span>
                        </div>
                      )}

                      {futureSchedules.map((schedule: any, index: number) => (
                        <div key={schedule.id} className="flex items-center gap-2">
                          <div className="bg-gray-100 p-1 rounded-sm flex items-center justify-center">
                            <CalendarIcon className="w-4 h-4" />
                          </div>
                          <span className="text-sm text-gray-700">{pastCount > 0 ? 'Send again:' : index === 0 ? 'Initial send:' : 'Send again:'}</span>
                          <span className="text-sm text-gray-700">{dayjs(schedule.start).format('MMM DD, YYYY')}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              }

              return null;
            })()}

          <div className="flex items-center gap-4 justify-center py-4">
            <Button kind="secondary" className="w-full" type="button" onClick={() => handleDeleteModal()}>
              Cancel
            </Button>
            <Button kind="danger" className="w-full" type="submit" onClick={() => deleteAutomationAction()}>
              Delete automation
            </Button>
          </div>
        </div>
      </BaseDialog>
      <BaseDialog size="max-w-2xl" open={Boolean(cancelModal)} onClose={() => handleCancelModal()}>
        <div className="border-b border-b-base-ghostWhite p-6 mb-6 flex gap-2 items-start justify-between">
          <div className="bg-base-antiFlash flex items-center p-2 rounded-lg">
            <BinIcon width={24} height={24} />
          </div>
          <div className="mr-auto my-auto">
            <h5 className="font-bold text-lg">Cancel automation</h5>
          </div>
          <div>
            <button type="button" onClick={() => handleCancelModal()}>
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className="px-6 pb-4">
          <p className="text-base-davyGray mb-4">Are you sure you want to cancel this automation? This action can not be undone.</p>

          {(cancelModal?.reviewRequestsToCancel ?? 0) > 0 &&
            (<p className="text-base-davyGray mb-4">
              This automation has
              <span className="font-bold">{` ${cancelModal?.reviewRequestsToCancel} started review requests`}</span>.
              These requests and their scheduled follow ups will be cancelled.
            </p>)
          }

          <div className="flex items-center gap-4 justify-center py-4">
            <Button kind="secondary" className="w-full" type="button" onClick={() => handleCancelModal()}>
              Close
            </Button>
            <Button kind="danger" className="w-full" type="submit" onClick={() => cancelAutomationAction()}>
              Cancel automation
            </Button>
          </div>
        </div>
      </BaseDialog>
    </>
  );
};
